/**
 * Text from the corpus, readable as a person would write it.
 *
 * Some corpus rows carry a character as a *typed-out escape* — the section
 * sign arrives as the six characters `\u00a7` rather than `§` — so a ground
 * chip read "\u00a7 2(d)" (TM-12). The data is the data; what a person sees
 * should not depend on how a source file happened to spell a symbol.
 *
 * Only `\uXXXX` is decoded, and only when it is exactly that. Nothing else is
 * interpreted: this is not an HTML or JSON parser, and a stray backslash in a
 * citation stays a backslash.
 */
export function plainText(text: string): string
export function plainText(text: string | null | undefined): string | null
export function plainText(text: string | null | undefined): string | null {
  if (text == null) return null
  return text.replace(/\\u([0-9a-fA-F]{4})/g, (_match, hex: string) =>
    String.fromCharCode(Number.parseInt(hex, 16)),
  )
}
